/**
 * UserRegisterContainer
 * --
 */
import React from 'react';
import UserRegisterPresenter from './UserRegisterPresenter';

const UserRegisterContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <UserRegisterPresenter />
    </>
  );
};

export default UserRegisterContainer;
